export const PngIcon = (props) => (
  <svg
    className={props.className}
    width="48"
    height="60"
    viewBox="0 0 48 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="44.7273"
      height="60"
      rx="2.5"
      fill="#7BA770"
      fillOpacity="0.3"
    />
    <rect
      x="4.83594"
      y="20.7273"
      width="42.7273"
      height="15.3818"
      rx="2.5"
      fill="#7BA770"
    />
    <path
      d="M21.974 26.9232C21.974 27.6459 21.7266 28.2025 21.2318 28.5931C20.7403 28.9805 20.0355 29.1742 19.1175 29.1742H18.2777V31.9818H17.4476V24.8431H19.2982C21.0821 24.8431 21.974 25.5365 21.974 26.9232ZM18.2777 28.4613H19.0248C19.7604 28.4613 20.2927 28.3425 20.6214 28.1049C20.9502 27.8672 21.1146 27.4864 21.1146 26.9623C21.1146 26.4903 20.96 26.1387 20.6507 25.9076C20.3415 25.6765 19.8597 25.5609 19.2054 25.5609H18.2777V28.4613ZM29.0492 31.9818H28.1019L24.2005 25.9906H24.1615C24.2136 26.6937 24.2396 27.3383 24.2396 27.9242V31.9818H23.473V24.8431H24.4105L28.3021 30.8099H28.3412C28.3347 30.7221 28.32 30.4405 28.2972 29.9652C28.2744 29.4867 28.2663 29.1449 28.2728 28.9398V24.8431H29.0492V31.9818ZM34.1517 28.2416H36.5785V31.7133C36.2009 31.8337 35.8168 31.9249 35.4261 31.9867C35.0355 32.0486 34.583 32.0795 34.0687 32.0795C32.988 32.0795 32.1465 31.7588 31.5443 31.1176C30.9421 30.473 30.641 29.5713 30.641 28.4125C30.641 27.6703 30.7891 27.0209 31.0853 26.4642C31.3848 25.9043 31.8145 25.4779 32.3744 25.1849C32.9343 24.8887 33.5902 24.7406 34.3421 24.7406C35.1039 24.7406 35.8135 24.8806 36.4711 25.1605L36.1488 25.893C35.5043 25.6195 34.8841 25.4828 34.2884 25.4828C33.4193 25.4828 32.7406 25.7416 32.2523 26.2592C31.764 26.7767 31.5199 27.4945 31.5199 28.4125C31.5199 29.376 31.7543 30.1068 32.223 30.6049C32.695 31.1029 33.3867 31.3519 34.2982 31.3519C34.793 31.3519 35.2764 31.295 35.7484 31.181V28.9838H34.1517V28.2416Z"
      fill="white"
    />
  </svg>
);
